import { GetIdTag } from "../interface/type";

export const GetById = () => {
  // const elementsWithId: Array<GetIdTag> = []
  // const allElements = document.getElementsByTagName('*')
  // for (let key in allElements) {
  //   if (allElements.hasOwnProperty(key)) {
  //     const element = allElements[key]
  //     if (element.id) {
  //       const result1: string = element.outerHTML;
  //       const tag = result1.substring(1, 3);
  //       var type = 0;
  //       switch (tag) {
  //         case "h1":
  //           type = 1;
  //           break;
  //         case "h2":
  //           type = 2;
  //           break;
  //         case "h3":
  //           type = 3;
  //           break;
  //         default:
  //           break;
  //       }
  //       elementsWithId.push({
  //         id: element.id,
  //         name: document.getElementById(element.id)?.textContent ?? "",
  //         type: type,
  //       });
  //     }
  //   }
  // }
  // if (window.flutter_inappwebview?.callHandler) {
  //   window.flutter_inappwebview.callHandler('getById', elementsWithId);
  // }
  // return elementsWithId;

  const elementsWithId: Array<GetIdTag> = [];
  const allElements = document.getElementsByTagName('*');

  for (let i = 0; i < allElements.length; i++) {
    const element = allElements[i];
    if (element.id) {
      const tag = element.tagName.toLowerCase(); // 태그 이름 가져오기
      let type = 0;
      var name = "표지";

      if (element.id === "cover") {
        type = 0;
      } else {
        name = element.textContent ?? "";
      }

      switch (tag) {
        case "h1":
          type = 1;
          break;
        case "h2":
          type = 2;
          break;
        case "h3":
          type = 3;
          break;
        default:
          break;
      }

      elementsWithId.push({
        id: element.id,
        name: name,
        type: type,
        isSelected: false,
        height: 0.0,
      });
    }
  }

  // Flutter로 전달
  if (window.flutter_inappwebview?.callHandler) {
    window.flutter_inappwebview.callHandler('getById', elementsWithId);
  }

  return elementsWithId;
}